import { isOwnApiUrl } from "@/lib/preview-fetch";

interface ImagePreviewProps {
	url: string;
	filename: string;
}

export function ImagePreview({ url, filename }: ImagePreviewProps) {
	return (
		<div className="flex h-full items-center justify-center p-4">
			<img
				src={url}
				alt={filename}
				crossOrigin={isOwnApiUrl(url) ? "use-credentials" : undefined}
				className="max-h-full max-w-full rounded-4 object-contain"
			/>
		</div>
	);
}
